import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'gem-feedback-chatbot-dialog',
  standalone: true,
  imports: [MatDialogModule],
  template: `
    <div mat-dialog-content class="gem-feedback-chatbot-dialog__content">
      <p class="gem-text-muted">Chatbot ist in dieser Anwendung nicht verfügbar.</p>
    </div>
  `,
})
export class GemFeedbackChatbotDialogComponent {}
